import { FunctionComponent } from 'react'

import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Link from '@mui/material/Link'
import url from 'libraries/front-end-core/core/url'
import cx from 'classnames'

import {
  DASHBOARD,
  LEGISLATION,
  SEARCH,
  LEGISLATION_REVIEW,
  CURRENT_AWARENESS_REVIEW,
  MW_LIST_DEALS,
  MW_ANALYTICS,
  MW_DEAL_DETAILS,
  MW_DEAL_COMPARE
} from 'constants/controllers'

const isRedirectToHomepage = (controller: string): boolean => [
  CURRENT_AWARENESS_REVIEW,
  LEGISLATION,
  LEGISLATION_REVIEW,
  SEARCH,
  MW_LIST_DEALS,
  MW_ANALYTICS,
  MW_DEAL_DETAILS,
  MW_DEAL_COMPARE
].includes(controller)

const CloseModalButton: FunctionComponent<CloseModalButtonProps> = ({ iconButtonCxNames = 'white', controller, setSignUpModalIsOpen }: CloseModalButtonProps) => {
  const redirectToHomepage = isRedirectToHomepage(controller)
  const handleOnClick = (): void => setSignUpModalIsOpen(false)

  return (
    <Link
      href={redirectToHomepage ? url(DASHBOARD) : undefined}
      className={cx('absolute right4 top4')}
    >
      <IconButton
        size='small'
        aria-label='close'
        className={cx('sign-up-close-button pa4', iconButtonCxNames)}
        onClick={handleOnClick}
      >
        <CloseIcon fontSize='small' />
      </IconButton>
    </Link>
  )
}

interface CloseModalButtonProps {
  iconButtonCxNames?: string
  controller: string
  setSignUpModalIsOpen: (value: boolean) => void
}

export default CloseModalButton
